import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import {
  type ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart"
import type { ChartDataPoint } from "@/types/dashboard"
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Line,
  XAxis,
  YAxis,
} from "recharts"

const chartConfig = {
  contacts: {
    label: "Contatos",
    color: "var(--color-primary)",
  },
  sales: {
    label: "Vendas",
    color: "var(--color-secondary)",
  },
  conversionRate: {
    label: "Taxa de Conversão",
    color: "var(--color-chart-1)",
  },
} satisfies ChartConfig

export function DashboardChart({ data }: { data: ChartDataPoint[] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Visão Geral</CardTitle>
        <CardDescription>Contatos, vendas e taxa de conversão dos últimos 6 meses</CardDescription>
      </CardHeader>
      <ChartContainer config={chartConfig} className="min-h-[250px] max-h-[350px] w-full px-6 pb-6">
        <ComposedChart data={data} accessibilityLayer>
          <CartesianGrid vertical={false} />
          <XAxis
            dataKey="month"
            tickLine={false}
            axisLine={false}
            tickMargin={8}
          />
          <YAxis
            yAxisId="left"
            tickLine={false}
            axisLine={false}
            tickMargin={8}
          />
          <YAxis
            yAxisId="right"
            orientation="right"
            tickLine={false}
            axisLine={false}
            tickMargin={8}
            domain={[0, 100]}
            tickFormatter={(v: number) => `${v}%`}
          />
          <ChartTooltip
            content={
              <ChartTooltipContent
                formatter={(value, name) => {
                  if (name === "conversionRate") return `${value}% Taxa de Conversão`
                  const label = name === "contacts" ? "Contatos" : "Vendas"
                  return `${value} ${label}`
                }}
              />
            }
          />
          <ChartLegend content={<ChartLegendContent />} />
          <Bar
            yAxisId="left"
            dataKey="contacts"
            stackId="a"
            fill="var(--color-contacts)"
            radius={[0, 0, 0, 0]}
            isAnimationActive={false}
          />
          <Bar
            yAxisId="left"
            dataKey="sales"
            stackId="a"
            fill="var(--color-sales)"
            radius={[4, 4, 0, 0]}
            isAnimationActive={false}
          />
          <Line
            yAxisId="right"
            dataKey="conversionRate"
            type="monotone"
            stroke="var(--color-conversionRate)"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
            isAnimationActive={false}
          />
        </ComposedChart>
      </ChartContainer>
    </Card>
  )
}
